import { Button, TextField } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ButtonZoom } from "../../utils/ButtonZoom";
import * as React from "react";
import { makeStyles } from "@mui/styles";
import { v2theme } from "../../../../styles/Theme";
import { generateGtmEvent } from "../../../../Helpers";

const useStyles = makeStyles((theme) => ({
  nameContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "16px",
  },
  btnContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  backButton: {
    padding: "0px",
    backgroundColor: "transparent",
    borderRadius: "8px",
    color: theme.palette.text.secondary,
    width: "90px",
    height: "45px",
    boxShadow: "none",
    fontSize: "16px",
    "&:hover": {
      backgroundColor: "#F2F2F2",
      width: "90px",
      height: "45px",
      textDecoration: "underline",
      color: theme.palette.text.primary,
      boxShadow: "none",
      transform: "none",
    },
  },
  inputText: {
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: v2theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: v2theme.palette.primary.main,
      },
    },
  },
}));

interface StepTwoProps {
  firstName: string;
  lastName: string;
  setFirstName: (firstName: string) => void;
  setLastName: (lastName: string) => void;
  email: string;
  setEmail: (email: string) => void;
  handleBack: (e: React.MouseEvent<HTMLButtonElement>) => void;
  handleNext: (e: React.MouseEvent<HTMLButtonElement>) => void;

  isDisabled: boolean;
}

export const UserDetailsStep = (props: StepTwoProps) => {
  const classes = useStyles();
  const {
    firstName,
    lastName,
    setFirstName,
    setLastName,
    email,
    setEmail,
    handleBack,
    handleNext,
    isDisabled,
  } = props;
  const HandleDataLayer = (
    event: string,
    action: string,
    name: string,
    type: string,
    region: string,
    section: string,
    text: string
  ) => {
    generateGtmEvent({ event, action, name, type, region, section, text });
  };
  return (
    <div>
      <div className={classes.nameContainer}>
        <TextField
          className={classes.inputText}
          id="first-name"
          label="First Name"
          type="text"
          value={firstName}
          onChange={(e) => {
            HandleDataLayer(
              "form",
              "click",
              "onclick",
              "blur",
              "main content",
              "create your account ^ first name",
              e.target.value
            );
            setFirstName(e.target.value);
          }}
          required
          variant="outlined"
          sx={{ marginRight: "16px" }}
        />
        <TextField
          className={classes.inputText}
          id="last-name"
          label="Last Name"
          type="text"
          value={lastName}
          onChange={(e) => {
            HandleDataLayer(
              "form",
              "click",
              "onclick",
              "blur",
              "main content",
              "create your account ^ last name",
              e.target.value
            );
            setLastName(e.target.value);
          }}
          required
          variant="outlined"
        />
      </div>
      <TextField
        className={classes.inputText}
        id="email"
        label="Email"
        type="email"
        required
        variant="outlined"
        fullWidth
        value={email}
        sx={{ marginBottom: "16px" }}
        onChange={(e) => {
          HandleDataLayer(
            "form",
            "click",
            "onclick",
            "blur",
            "main content",
            "create your account ^ email",
            e.target.value
          );
          setEmail(e.target.value);
        }}
      />
      <div className={classes.btnContainer}>
        <Button
          size="medium"
          className={classes.backButton}
          variant="contained"
          sx={{ marginLeft: "-0.85em" }}
          startIcon={<ArrowBackIcon style={{ width: "16px", height: "16px" }} />}
          onClick={(e) => {
            HandleDataLayer(
              "link",
              "click",
              "onclick",
              "internal link",
              "main content",
              "create your account",
              "Back"
            );
            handleBack(e);
          }}>
          Back
        </Button>
        <ButtonZoom
          onClick={(e) => {
            HandleDataLayer(
              "link",
              "click",
              "onclick",
              "internal link",
              "main content",
              "create your account",
              "Continue"
            );
            handleNext(e);
          }}
          sx={{ width: "146px", height: "62px" }}
          disabled={isDisabled}
          size="large"
          variant="contained"
          color="secondary">
          Continue
        </ButtonZoom>
      </div>
    </div>
  );
};
